/**
 * @typedef {import('./lib/index.js').Options} Options
 */

export {gfmFromMarkdown, gfmToMarkdown} from './lib/index.js'
